@let cfg = config();

<aside
  [class]="
    'bg-white border-r border-default flex flex-col h-full transition-all duration-300 ease-in-out shrink-0 ' +
    (isTablet()
      ? collapsed()
        ? 'fixed left-0 top-0 z-50 h-screen w-full -translate-x-full'
        : 'fixed left-0 top-0 z-50 h-screen w-full translate-x-0'
      : isFloating()
        ? collapsed()
          ? 'fixed left-0 top-0 z-50 h-screen w-52 -translate-x-full'
          : 'fixed left-0 top-0 z-50 h-screen w-52 translate-x-0 shadow-xl'
        : collapsed() && cfg.collapseMode === 'mini'
          ? 'w-18 ml-0'
          : collapsed()
            ? 'w-52 -ml-52'
            : 'w-52 ml-0') +
    ' ' +
    (collapsed() && cfg.collapseMode !== 'mini' ? 'pointer-events-none' : '') +
    ' ' +
    styleClass()
  "
>
  <!-- Close Button for Mobile -->
  @if (showCloseButton()) {
    <div class="flex justify-end p-4">
      <button
        nbxButton
        type="button"
        variant="action"
        icon="pi pi-times"
        [attr.aria-label]="'COMMON.CLOSE' | transloco"
        (click)="collapsed.set(true)"
      ></button>
    </div>
  }

  @if (cfg.logo) {
    <div
      [class]="
        'flex w-full items-center overflow-hidden ' +
        (collapsed() && cfg.collapseMode === 'mini' ? 'justify-center p-4' : 'min-h-[107px] px-6 py-5')
      "
    >
      <img
        [src]="collapsed() && cfg.collapseMode === 'mini' ? (cfg.collapsedLogo ?? cfg.logo) : cfg.logo"
        [alt]="cfg.logoAlt ?? 'Logo'"
        class="h-10 max-w-full object-contain object-left"
      />
    </div>
  }

  <div class="flex flex-1 flex-col items-start w-full h-full">
    @for (item of cfg.items; track $index) {
      @if (item.isHeader) {
        <!-- Section Header -->
        <div class="w-full px-4 pt-6 pb-2 text-xs font-semibold text-secondary uppercase tracking-wider">
          {{ item.label | transloco }}
        </div>
      } @else {
        <!-- Regular Menu Item -->
        <a
          nbxButton
          variant="sidebar"
          class="w-full relative"
          [class.pointer-events-none]="item.disabled"
          [class.justify-center]="collapsed() && cfg.collapseMode === 'mini'"
          [class.opacity-50]="item.disabled"
          [icon]="item.icon!"
          [label]="collapsed() && cfg.collapseMode === 'mini' ? null : (item.label | transloco)"
          [href]="item.route && !item.disabled ? item.route : undefined"
          [routerLink]="item.routerLink && !item.disabled ? item.routerLink : undefined"
          [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? { exact: false }"
          routerLinkActive="selected"
          (click)="onItemClick()"
        >
          @if (item.badge) {
            <p-badge
              [value]="item.badge"
              severity="danger"
              class="absolute top-2 right-2"
            />
          }
        </a>
      }
    }

    @if (cfg.bottomItems?.length) {
      <div class="mt-auto w-full">
        @for (item of cfg.bottomItems; track $index) {
          <a
            nbxButton
            variant="sidebar"
            class="w-full relative"
            [class.pointer-events-none]="item.disabled"
            [class.justify-center]="collapsed() && cfg.collapseMode === 'mini'"
            [class.opacity-50]="item.disabled"
            [icon]="item.icon!"
            [label]="collapsed() && cfg.collapseMode === 'mini' ? null : (item.label | transloco)"
            [href]="item.route && !item.disabled ? item.route : undefined"
            [routerLink]="item.routerLink && !item.disabled ? item.routerLink : undefined"
            [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? { exact: false }"
            routerLinkActive="selected"
            (click)="onItemClick()"
          >
            @if (item.badge) {
              <p-badge
                [value]="item.badge"
                [severity]="item.badgeSeverity || 'secondary'"
                class="absolute top-2 right-2"
              />
            }
          </a>
        }
      </div>
    }
  </div>
</aside>
